export default {"src":"/_next/static/media/cpp-logo.c426ae6d.svg","height":58,"width":52,"blurWidth":0,"blurHeight":0};